var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-video-viewer",class:{showing: _vm.visible}},[_c('video',{ref:"media",attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }